import clsx from "clsx";
import { Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import * as yup from "yup";

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";

import { MyTextField } from "../../custom/MyTextField";
import {
  CommunicationChannels,
  CommunicationChannelsList,
  CorrespondenceInputType,
} from "../../../enums/enums";
import { IUserCorrespondence } from "../../../interfaces/Correspondence";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useStyles } from "../../../shared/styles/useStyles";

interface Props {
  onSearch(data: any): void;
  module: { type: string; rol: string };
}

const initialValues = {
  dependency: "",
  inputType: "",
  startDate: new Date().toLocaleDateString("en-CA"),
  endDate: new Date().toLocaleDateString("en-CA"),
  channel: "",
};

export const CorrespondenceReceivedForm: FC<Props> = ({ onSearch, module }) => {
  const classes = useStyles();
  const intl = useIntl();
  const { productionOffices } = useSelector((state: AppState) => state.trd);
  const { latestProductionOffices } = useSelector((state: AppState) => state.trd);
  useState<IUserCorrespondence | null>(null);
  const { office } = useSelector((state: AppState) => state.documentManagment);
  const [officeState, setOfficerState] = useState("");
  const [disabledOffice, setDisabledOffice] = useState(false);
  const [comunication, setComunication] = useState<{ value: string; name: string }[]>(
    [ { value: "Todos", name: "All" },]
  );


  const validationSchema = yup.object({
    dependency: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    inputType: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    startDate: yup
      .date()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`)
      .max(
        yup.ref("endDate"),
        `${intl.formatMessage({ id: "GreaterStartDate" })}`
      ),
    endDate: yup
      .date()
      .min(
        yup.ref("startDate"),
        `${intl.formatMessage({ id: "LowerEndDate" })}`
      )
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    channel: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
  });

  const handleOfficer = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOfficerState(event.target.value);
  };


  useEffect(() => {
    setComunication([...comunication, ...CommunicationChannelsList] )
  }, []);

  
  useEffect(() => {
    if (office) {
      setOfficerState(office.id);
    }

    if (office && module.type == "management") {
      const index = latestProductionOffices.findIndex(
          (item) => item.id === office.id
      );
      // Reemplaza productionOffices por latestProductionOffices en la búsqueda
      setOfficerState(latestProductionOffices[index]?.id || "");
      setDisabledOffice(true);
    }
  }, [office, latestProductionOffices]);
  return (
    <Box mt={1} mb={3}>
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        //validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          values.dependency = officeState;
          setSubmitting(true);
          onSearch(values);
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, values }) => (
          <Form className={classes.input}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <FormattedMessage id="Dependency" />
                <TextField
                  id="dependency"
                  name="dependency"
                  select
                  variant="outlined"
                  value={officeState}
                  SelectProps={{
                    native: true,
                  }}
                  className={classes.customSelect}
                  onChange={handleOfficer}
                  disabled={disabledOffice}
                >
                  <option value="Todos">Todos</option>
                  {latestProductionOffices.map((item) => (
                      // Reemplaza productionOffices.map por latestProductionOffices.map
                      <option key={item.id} value={item.id}>
                        {/* También cambia item.idProductionOffice por item.id */}
                        {item.name}
                      </option>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="InputType" />

                <MyTextField
                  name="inputType"
                  variant="outlined"
                  select
                  className={classes.myTextFieldRoot}
                  required
                >
                  <MenuItem value="Todos">Todas</MenuItem>
                  <MenuItem value={CorrespondenceInputType.ER}>
                    <FormattedMessage id="ExternalReceived" />
                  </MenuItem>
                  <MenuItem value={CorrespondenceInputType.IR}>
                    <FormattedMessage id="InternalReceived" />
                  </MenuItem>
                  <MenuItem value={CorrespondenceInputType.OR}>
                    <FormattedMessage id="OtherShipmentsReceived" />
                  </MenuItem>

                  {/* <MenuItem value={CorrespondenceInputType.EP}>
                        <FormattedMessage id="ExternalProduced" />
                      </MenuItem>
                      <MenuItem value={CorrespondenceInputType.IP}>
                        <FormattedMessage id="InternalProduced" />
                      </MenuItem>
                      <MenuItem value={CorrespondenceInputType.OP}>
                        <FormattedMessage id="OtherShipmentsProduced" />
                      </MenuItem> */}
                </MyTextField>
              </Grid>


              <Grid item xs={12} sm={4}>
                  <FormattedMessage id="Channel" />*
                <MyTextField
                  name="channel"
                  variant="outlined"
                  select
                  className={classes.myTextFieldRoot}
                  required
                >
                  {comunication.map((channel) => (
                    <MenuItem key={channel.value} value={channel.value}>
                      {intl.formatMessage({ id: channel.name })}
                    </MenuItem>
                  ))}
                </MyTextField>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="From" />
                <MyTextField
                  name="startDate"
                  variant="outlined"
                  type="date"
                  className={classes.myTextDate}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="To" />
                <MyTextField
                  name="endDate"
                  variant="outlined"
                  type="date"
                  className={classes.myTextDate}
                />
              </Grid>

              <Grid
                item
                xs={4}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {!isSubmitting ? (
                  <Button
                    className={clsx(classes.btnAction, classes.save)}
                    autoFocus
                    type="submit"
                    disabled={isSubmitting}
                    style={{ marginTop: "8px", width: "40%" }}
                  >
                    <FormattedMessage id="Download" />
                  </Button>
                ) : (
                  <Button
                    className={clsx(classes.btnAction, classes.save)}
                    autoFocus
                    type="button"
                    disabled={true}
                    style={{ marginTop: "8px", width: "40%" }}
                  >
                    <CircularProgress className={classes.btnLoading} />
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
